import { createElement } from "../DOMutils";

class Toaster {
    constructor() {
        if (Toaster._instance) {
            return Toaster._instance;
        }
        Toaster._instance = this;
        this.toasts = {};
    }

    createToasterEl() {
        if (!this.el) {
            this.el = createElement("div", { class: "toaster" });
            document.body.appendChild(this.el);
        }
    }

    createToast(id, text) {
        const toast = { id };
        const toastEl = createElement("div", { class: "toast" });
        const textEl = createElement("p", {}, text);
        const closeButtonEl = createElement("button", {
            type: "button",
            class: "toast__close cross",
            "aria-label": "Close",
        });

        toastEl.appendChild(textEl);
        toastEl.appendChild(closeButtonEl);

        toast["el"] = toastEl;

        closeButtonEl.addEventListener("click", this.handleCloseClick.bind(null, toast));
        toastEl.addEventListener("animationend", this.handleAnimationEnd.bind(this, toast));

        return toast;
    }

    addToast(toast) {
        if (this.toasts[toast.id]) return;

        this.createToasterEl();
        this.toasts[toast.id] = toast.el;
        this.el.prepend(toast.el);
    }

    handleCloseClick(toast) {
        toast.el.style.animation = "fadeOutTop 1 0.4s";
    }

    handleAnimationEnd(toast) {
        toast.el.remove();
        delete this.toasts[toast.id];
    }
}

export default new Toaster();
